import React, {useEffect} from "react";
import {
    Spacer
} from "@nextui-org/react";
import {
    getCurrentDate
} from "../inc/js/Helper";

export default function Footer() {
    const currentDate = getCurrentDate();
    const currentYear = new Date(currentDate).getFullYear();
    const APP_VERSION = "0.1.020226";

    return(
        <div>
            <Spacer y={20} />
            <footer className="bg-blue-500 text-white py-6 sm:border-t-2 sm:border-black">
                <div className="mx-auto px-4">
                    <div className="flex justify-between items-center text-xs sm:text-sm">
                        <div className="max-w-32 sm:max-w-full">
                            <p className="text-sm">
                                &copy; {currentYear} JudgeAutos.com. All rights reserved.
                            </p>
                            <p className="text-xs text-gray-700 mt-1">
                                Version {APP_VERSION}
                            </p>
                        </div>
                        <div className="flex space-x-4">
                            <a href="/PrivacyPolicy" className="hover:underline">Privacy Policy</a>
                            <a href="/ContactUs" className="hover:underline">Contact Us</a>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    );
}